import 'dmn-js/dist/assets/diagram-js.css';
import 'dmn-js/dist/assets/dmn-font/css/dmn-embedded.css';
import 'dmn-js/dist/assets/dmn-js-decision-table-controls.css';
import 'dmn-js/dist/assets/dmn-js-decision-table.css';
import 'dmn-js/dist/assets/dmn-js-drd.css';
import 'dmn-js/dist/assets/dmn-js-literal-expression.css';
import 'dmn-js/dist/assets/dmn-js-shared.css';
import DmnJS from 'dmn-js/lib/Modeler';
import Component from 'formiojs/components/_classes/component/Component';

export class dmnComponent extends Component {
    private detachListener: (() => void) | null = null;
    private modeler: any = null;

    /* ---------- meta ---------- */
    static schema(...extend: any[]) {
        return Component.schema({
            type: 'dmnComponent',
            label: 'DMN',
            key: 'dmnComponent',
            inputType: 'string',
            height: '500px',
            ...extend,
        });
    }

    static get builderInfo() {
        return {
            title: 'DMN',
            group: 'advanced',
            icon: 'project-diagram',
            documentation: 'https://bpmn.io/toolkit/bpmn-js/',
            schema: dmnComponent.schema(),
        };
    }

    private onChanged = () => {
        this.modeler.saveXML({ format: true }, (err: any, xml: any) => {
            if (!err) super.setValue(xml, false, false);
        });
    };

    /* ---------- life-cycle ---------- */
    setValue(value: string, flags: any, initial = true) {
        if (typeof value !== 'string') return;

        this.modeler.importXML(value, (err: any) => {
            if (err) console.error('Error parsing XML', err);
        });

        if (initial) super.setValue(value, flags);
    }

    attach(el: HTMLElement) {
        const attached = super.attach(el);
        (this as any).loadRefs(el, { canvas: 'single' });

        const modeler = new DmnJS({
            container: (this as any).refs.canvas,
            keyboard: { bindTo: document },
        });
        this.modeler = modeler;

        this.detachListener = null;

        /* after the XML is in */
        modeler.on('import.done', ({ error }) => {
            if (error) {
                console.error(error);

                return;
            }
            this.wireViewer(modeler.getActiveViewer(), this.onChanged);
        });

        /* every time the user switches DRD ↔ table ↔ literal expression … */
        modeler.on('views.changed', () =>
            this.wireViewer(modeler.getActiveViewer(), this.onChanged),
        );

        return attached;
    }

    /**
     * (Re-)attach a single `elements.changed` listener
     * to the viewer that is active right now.
     */
    wireViewer(viewer: any, onChanged: () => void) {
        if (!viewer) return; // guard

        /* remove old handler */
        if (this.detachListener) {
            this.detachListener();
        }
        this.detachListener = null;

        const bus = viewer.get('eventBus');

        bus.on('elements.changed', onChanged);
        this.detachListener = () => bus.off('elements.changed', onChanged);
    }

    detach() {
        if (this.detachListener) {
            this.detachListener();
        }
        if (this.modeler) {
            this.modeler.destroy();
        }

        return super.detach();
    }

    /* ---------- render ---------- */
    render() {
        return super.render(`
      <div style="height:${(this as any).component.height}">
        <div ref="canvas" style="height:100%; border:1px solid #ccc;"></div>
      </div>
    `);
    }
}
